import { ReactElement, useEffect } from 'react';

/**
 * NavigationScroll - A component that scrolls the window to the top
 * whenever the route changes. Wrap this around components that should
 * start with the window scrolled to the top.
 */
const NavigationScroll = ({ children }: { children: ReactElement | null }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  return children || null;
};

export default NavigationScroll;
